export default __webpack_public_path__ + "static/media/gallery-1.2d450ece.jpg";